import styled from 'styled-components';

export const Section = styled.div`
  max-width: 1200px;
  padding: 100px 25px;
  margin: auto;
`;

export const MainTitle = styled.h1`
  font-size: 3rem;
`;

export const MainTitleMid = styled(MainTitle)`
  text-align: center;
  margin: 5px 0;
`;

export const Paragraf = styled.p`
  font-size: 1.5rem;
  opacity: 0.8;
  font-weight: 400;
  line-height: 2.4rem;
`;

export const ParagrafMid = styled(Paragraf)`
  text-align: center;
  max-width: 450px;
  margin: auto;
`;

export const MainBtn = styled.button`
  display: inline-block;
  box-sizing: content-box;
  max-width: 150px;
  font-style: normal;
  font-variant-caps: normal;
  font-variant-ligatures: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 700;
  font-stretch: normal;
  font-size: 14px;
  line-height: 12px;
  padding: 15px 25px;
  background-color: ${({ theme }) => theme.mainColors.hvid};
  border: none;
  border-radius: 12px;
  box-shadow: 0 20px 30px 0 rgb(0 0 29 / 7%);
  transition: all 250ms ease-out;
  &:hover {
    transform: translate3d(0, 3px, 0) scale3d(0.95, 0.95, 1);
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.25);
    cursor: pointer;
  }
  &:active {
    transform: translate3d(0, 3px, 0) scale3d(0.9, 0.9, 1);

    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  }
`;

export const SecondaryBtn = styled.button`
  box-sizing: border-box;
  text-align: center;
  width: 200px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  margin: 20px 0;
  height: 55px;
  text-align: center;
  border: none;
  background-size: 300% 100%;

  border-radius: 5px;
  moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.3s ease-out;

  background-image: linear-gradient(
    to right,
    #25aae1,
    #4481eb,
    #04befe,
    #3f86ed
  );
  box-shadow: 0 15px 30px 0 rgba(65, 132, 234, 0.25);

  &:hover {
    background-position: 100% 0;

    transform: translate3d(0, 3px, 0) scale3d(0.95, 0.95, 1);

    box-shadow: 0 5px 10px 0 rgba(65, 132, 234, 0.75);
  }
  &:focus {
    outline: none;
  }
  &:active {
    transform: translate3d(0, 3px, 0) scale3d(0.9, 0.9, 1);
    box-shadow: 0 2px 5px 0 rgba(65, 132, 234, 0.5);
  }
`;

export const FeaturesImgLeft = styled(Section)`
  display: flex;
  padding: 100px 25px;
  flex-direction: row;
  justify-content: space-between;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
    row-gap: 25px;
  }
  & div:first-child {
    display: flex;
    flex-basis: 40%;
    flex-grow: 0;
    flex-shrink: 0;
    max-width: 100%;
    align-items: center;
    & img {
      max-width: 100%;
      border-radius: 20px;
      box-shadow: 0 20px 30px 0 rgb(0 0 29 / 7%);
    }
  }
  & div:last-child {
    flex-basis: 50%;
    flex-grow: 0;
    flex-shrink: 0;
    & h1 {
      font-size: 2.5rem;
      margin: 0;
    }
    & h2 {
      font-size: 2rem;
      margin: 0;
    }
    & p {
      font-size: 1.25rem;
      opacity: 0.8;
      font-weight: 400;
  }
`;